import { callApi } from './api';

export const deleteUser = async (role: string, email: string) => {
  const { status, result } = await callApi<null>(
    'users/user',
    'DELETE',
    undefined,
    {
      email: email,
      role: role,
    },
    undefined,
    undefined,
    true
  );
  return { status, result };
};
